<template>
  <div class="home-wapper">
    <div class="title clearfloat">
      <div class="logo" @click="toFloorNum(1)">
        <img src="~images/home/zebra-logo.png" alt />
      </div>
      <div class="nav-model">
        <div class="nav-item" @click="toFloorNum(1)" :class="{'colorActive': sectionIndex == 1}">首页</div>
        <div class="nav-item" @click="toFloorNum(3)" :class="{'colorActive': sectionIndex == 3}">权益</div>
        <div class="nav-item" @click="toFloorNum(4)" :class="{'colorActive': sectionIndex == 4}">品牌资讯</div>
        <div
          class="nav-item"
          @click="toFloorNum(5)"
          :class="{'colorActive': sectionIndex == 5}"
        >合作伙伴</div>
        <div
          class="nav-item"
          @click="toRuleCenter(5)"
        >规则中心</div>
        <div class="nav-item" @click="toFloorNum(6)" :class="{'colorActive': sectionIndex == 6}">关于我们</div>
        <!--<div class="nav-item" @click="toFloorNum(9)" :class="{'colorActive': sectionIndex == 9}">招商</div>-->
        <!-- <div class="nav-item voice-ctrl" v-if="sectionIndex == 1" @click="voiceCtrl"><img v-if="voiceVisible" src="~images/home/voice-close.png" alt=""><img v-if="!voiceVisible" src="~images/home/voice-open.png" alt=""></div> -->
      </div>
    </div>
    <div class="full" id="fullpage">
      <div class="section">
        <Floor1 ref="myChild"></Floor1>
      </div>
      <div class="section">
        <Floor2></Floor2>
      </div>
      <!--<div class="section">-->
        <!--<Floor8></Floor8>-->
      <!--</div>-->
      <div class="section">
        <Floor3></Floor3>
      </div>
      <div class="section">
        <Floor4></Floor4>
      </div>
      <!--<div class="section">-->
        <!--<Floor5></Floor5>-->
      <!--</div>-->
      <div class="section">
        <Floor6></Floor6>
      </div>
      <div class="section">
        <Floor7></Floor7>
      </div>
      <!--<div class="section">-->
        <!--<Floor9></Floor9>-->
      <!--</div>-->
      <!--<div class="section">-->
        <!--<Floor10></Floor10>-->
      <!--</div>-->
    </div>
    <div class="footer-wrapper">
      <div class="footer">
        <div class="row-wrapper">
          <div class="row clearfloat">
            <span @click="goto(7)" >增值电信业务经营许可证：浙B2-20190311 &nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span
              class="beian"
              @click="jumpBeian"
            >{{icp}}</span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span @click="goto(1)">{{yyzz}} </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span @click="goto(2)">食品经营许可证：JY13301060253385 </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span @click="goto(3)">第二类医疗器械经营备案凭证：浙杭食药监械经营备20191771号 </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span @click="goto(4)">医疗器械经营许可证（三类）：浙杭食药监械经营许20190525号  </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span @click="goto(5)">出版物网络交易平台服务经营备案证：新出发浙备字第2021004号 </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span @click="goto(6)">互联网药品信息服务资格证书：(浙)-经营性-2019-0142 </span>
            <br/>
            <span @click="goto(8)">医疗器械网络交易服务第三方平台备案号：（浙）网械平台备字[2020]第00003号 </span>

            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602010425"
              style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin-left: 5px;"
            />
            <img
              v-if="showZgwab"
              src="https://img.gegejia.com/img/e7bbe63bc36af66620682570e0c43006.png"
              style="float:left;width:20px;height:20px;margin-top:4px;"
            />
            <p
              v-if="showZgwab"
              style="float:left;height:20px;line-height:20px;margin: 6px 0px 0px 5px; color:rgba(255, 255, 255, 0.8);font-size:12px;"
            >浙公网安备 33010602010425号</p>
          </div>
          <div class="slide-down pointer" @click="slideDown" v-if="sectionIndex != 6">
            <img src="~images/home/slide-down.png" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/jquery.fullPage.css";
import "@/assets/js/jquery.easings.min.js";
import "@/assets/js/jquery.fullPage.js";
// import getBeians from "@lib/ggj-beian";
import Floor1 from "@/views/floor/floor_1";
import Floor2 from "@/views/floor/floor_2";
import Floor3 from "@/views/floor/floor_3";
import Floor4 from "@/views/floor/floor_4";
import Floor5 from "@/views/floor/floor_5";
import Floor6 from "@/views/floor/floor_6";
import Floor7 from "@/views/floor/floor_7";
import Floor8 from "@/views/floor/floor_8";
import Floor9 from "@/views/floor/floor_9";
import Floor10 from "@/views/floor/floor_10";

function getBeians() {
    return new Promise(resolve => {
        const beians = {
            'yangege.com': "浙ICP备10030838号-4",
            'yangege.cn': "浙ICP备10030838号-5",
            'gegejia.com': "浙ICP备10030838号-6",
            '51yanwang.com': "浙ICP备10030838号-8",
            '51yanwang.cn': "浙ICP备10030838号-8",
            '91bushou.com': "浙ICP备10030838号-9",
            '51bushou.com': "浙ICP备10030838号-9",
            'gegeselect.com': "浙ICP备10030838号-11",
            'gegejia.net': '浙ICP备10030838号-7',
            'gegejia.com.cn': '浙ICP备10030838号-7',
            'gegeselect.net': '浙ICP备10030838号-11',
            'ixiaoqule.com': '浙ICP备10030838号-12',
            'zebraprime.com': '浙ICP备19011834号-8',
            'bm.cn': '浙ICP备19011834号',
            'myzebravip.com': '浙ICP备19011834号-1',
        }
        resolve(beians)
    })
}

function getDataByUrl() {
  return getBeians();
}

function getIcp(icpMap) {
  for (let suffix in icpMap) {
    if (new RegExp(`${suffix}(\/)?$`).test(location.href)) {
      return icpMap[suffix];
    }
  }
}

export default {
  data() {
    return {
      sectionIndex: 1,
      footerCodeVisible: false,
      voiceVisible: true,
      icp: "浙ICP备19011834号-1"
    };
  },
  components: {
    Floor1,
    Floor2,
    Floor3,
    Floor4,
    Floor5,
    Floor6,
    Floor7,
    Floor8,
    Floor9,
    Floor10
  },
  created: function() {
    document.title = '斑马会员官网——斑马在手，省遍全球'
    getDataByUrl().then(icpMap => {
      if (icpMap) {
        const icp = getIcp(icpMap);
        if (icp) {
          this.icp = icp;
        }
      }
    });
    let self = this;
    $(document).ready(function() {
      $("#fullpage").fullpage({
        //anchors: ['firstPage', 'secondPage', 'thirdPage', 'fourthPage', 'lastPage'],
        afterLoad: function(anchorLink, index) {
          console.log(index, "index");
          self.sectionIndex = index;
        },
        normalScrollElements: ".card"
      }); //激活fullpage
    });
  },
  computed: {
    yyzz() {
      return location.href.indexOf("bm.cn") > -1
        ? "迅兰营业执照：91330106MA2CE07531"
        : "格家营业执照：91330106341780594J";
    },
    showZgwab() {
      return location.href.indexOf("bm.cn") > -1;
    }
  },
  methods: {
    goto(v) {
      if (v === 1) {
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E8%BF%85%E5%85%B0%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7%EF%BC%9A91330106MA2CE07531.jpg");
      } else if (v ===2 ){
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E9%A3%9F%E5%93%81%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81%EF%BC%9AJY13301060024385.jpg");

      } else if (v ===3 ){
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E7%AC%AC%E4%BA%8C%E7%B1%BB%E5%8C%BB%E7%96%97%E5%99%A8%E6%A2%B0%E7%BB%8F%E8%90%A5%E5%A4%87%E6%A1%88%E5%87%AD%E8%AF%81%EF%BC%9A%E6%B5%99%E6%9D%AD%E9%A3%9F%E8%8D%AF%E7%9B%91%E6%A2%B0%E7%BB%8F%E8%90%A5%E5%A4%8720191771%E5%8F%B7.jpg");

      } else if (v ===4 ){
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E5%8C%BB%E7%96%97%E5%99%A8%E6%A2%B0%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81%EF%BC%88%E4%B8%89%E7%B1%BB%EF%BC%89%EF%BC%9A%E6%B5%99%E6%9D%AD%E9%A3%9F%E8%8D%AF%E7%9B%91%E6%A2%B0%E7%BB%8F%E8%90%A5%E8%AE%B820190525%E5%8F%B7.jpg");

      } else if (v ===5 ){
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E5%87%BA%E7%89%88%E7%89%A9%E7%BD%91%E7%BB%9C%E4%BA%A4%E6%98%93%E5%B9%B3%E5%8F%B0%E6%9C%8D%E5%8A%A1%E7%BB%8F%E8%90%A5%E5%A4%87%E6%A1%88%E8%AF%81%EF%BC%9A%E6%96%B0%E5%87%BA%E5%8F%91%E6%B5%99%E5%A4%87%E5%AD%97%E7%AC%AC2019004%E5%8F%B7.png");

      } else if (v ===6 ){
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E8%BF%85%E5%85%B0%E4%BA%92%E8%81%94%E7%BD%91%E8%8D%AF%E5%93%81%E4%BF%A1%E6%81%AF%E6%9C%8D%E5%8A%A1%E8%AF%81%E4%B9%A6%EF%BC%9A(%E6%B5%99)-%E7%BB%8F%E8%90%A5%E6%80%A7-2019-0142.jpg");

      } else if (v ===7 ){
        window.open("https://cdn.gegejia.com/fe-ui/bm/%E5%A2%9E%E5%80%BC%E7%94%B5%E4%BF%A1%E4%B8%9A%E5%8A%A1%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81%EF%BC%9A%E6%B5%99%20B2-20190311.jpg");

      }else if (v ===8 ){
        window.open("https://www.nmpa.gov.cn/datasearch/home-index.html?79QlcAyHig6m=1658976537218#category=ylqx");

      }
    },
    slideDown() {
      $("#fullpage").fullpage.moveSectionDown();
      //$("#fullpage").fullpage.moveTo(3)
    },
    toFloorNum(num) {
      $("#fullpage").fullpage.moveTo(num);
    },
    wechatClick() {
      this.footerCodeVisible = !this.footerCodeVisible;
    },
    voiceCtrl() {
      this.voiceVisible = !this.voiceVisible;
      this.$refs.myChild.muteStatusCtrl();
    },
    toRuleCenter(index) {
      this.sectionIndex = index;
      window.location.href =
        "https://h5.gegejia.com/adminUniversity/#/rules?page=1&pageSize=20&menuId=12";
    },
    jumpBeian() {
      window.open("https://beian.miit.gov.cn/");
    }
  }
};
</script>

<style scoped lang="less">
.home-wapper {
  font-family: "HYQiHei", "DIN", "PingFang";
  // width: 100%;
  // height: 100%;
  overflow: hidden;
  background-color: #000;
  .title {
    position: absolute;
    top: 6.5%;
    left: 0;
    z-index: 200;
    width: 100%;
    overflow: hidden;
    min-width: 1200px;
    .logo {
      float: left;
      margin-left: 7.5%;
      width: 365px;
      height: 34px;
      margin-right: 7.5%;
      cursor: pointer;
      img {
        width: 100%;
      }
    }
    .nav-model {
      float: right;
      display: flex;
      margin-right: 96px;
      .nav-item {
        margin-right: 35px;
        color: #fff;
        font-size: 16px;
        line-height: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        cursor: pointer;
      }
      .nav-item:last-child {
        margin-right: 0;
      }
      .colorActive {
        color: #ffff40;
      }
      .voice-ctrl {
        img {
          width: 22px;
          height: 22px;
        }
      }
    }
  }
  .footer-wrapper {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 3.6%;
    font-size: 12px;
    color: #fff;
    min-width: 1200px;
    .footer {
      margin-left: 7.5%;
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      line-height: 20px;
      .row-wrapper {
        position: relative;
        width: 100%;
        .row {
          position: relative;
          width: 78%;
          vertical-align: middle;
          .special {
            font-weight: 600;
            float: left;
            margin-right: 22px;
            line-height: 26px;
          }
          .opa {
            filter: alpha(opacity=80); /*支持 IE 浏览器*/
            -moz-opacity: 0.8; /*支持 FireFox 浏览器*/
            -khtml-opacity: 0.8; /*webkit内核浏览器*/
            opacity: 0.8;
            margin-right: 22px;
            float: left;
            line-height: 26px;
            a {
              text-decoration: none;
              color: #fff;
            }
          }
          img {
            width: 26px;
            height: 26px;
          }
          .weibo {
            margin-right: 6px;
            //float: left;
            display: inline-block;
            vertical-align: middle;
          }
          .wechat {
            margin-right: 6px;
            position: relative;
            //float: left;
            display: inline-block;
            vertical-align: middle;
            .footer-code {
              width: 26px;
              height: 26px;
              background-color: #fff;
              position: absolute;
              left: 32px;
              bottom: 4px;
              img {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 120px;
                height: 120px;
                border-radius: 20px 20px 20px 0;
              }
            }
          }
          .pointer {
            cursor: pointer;
            a {
              display: inline-block;
              vertical-align: middle;
            }
          }
        }
        .slide-down {
          position: absolute;
          //float: right;
          right: 143px;
          bottom: 10px;
          width: 2%;
          img {
            width: 100%;
          }
        }
      }
    }
  }
  .clearfloat:after {
    content: "";
    display: block;
    clear: both;
  }
  .clearfloat {
    zoom: 1;
    span{
      cursor: pointer;
    }
    span:hover{
      text-decoration: underline;
    }
    .beian {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .bossss{
    display: block;
    color: #ccc;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue